module.exports = __webpack_public_path__ + "static/media/CAA.4780989f.png";